import React from "react"
import { useSelector } from "react-redux"
import ChannelPopover from "./components/ChannelPopover"

import OptIn from "./OptIn"
import { useAppDispatch } from "./store"
import { selectChannel, selectSupportInfo } from "./store/selectors"
import { loadSupportInfo, optOutChannel, registerChannel } from "./store/thunks"

const ChannelMenu: React.FC = () => {
  const dispatch = useAppDispatch()
  const optIn = React.useCallback(() => dispatch(registerChannel()), [dispatch])
  const optOut = React.useCallback(() => dispatch(optOutChannel()), [dispatch])

  const channel = useSelector(selectChannel)
  const supportInfo = useSelector(selectSupportInfo)

  React.useEffect(() => {
    dispatch(loadSupportInfo())
  }, [dispatch])

  return (
    <>
      {channel ? (
        <ChannelPopover channel={channel} onOptOut={optOut} onOptIn={optIn} />
      ) : (
        supportInfo && <OptIn supportInfo={supportInfo} />
      )}
    </>
  )
}

export default ChannelMenu
